/**
 * We don't want the contract module to have dependency on utils module that is why we create
 * this function here
 * @param prefix - the prefix of _id, an sensible short name of entity
 */
export function generateEntityId(prefix = 'ent', length = 15) {
  //it just shadows the random string from the generateId function

  let result = ''
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'

  for (let i = length; i > 0; i -= 1) {
    result += chars[Math.floor(Math.random() * chars.length)]
  }

  return `${prefix}_${result}`
}
